export const UserAuthListState = {
    isLoading: false,
    heartRunnerList: [],
    errorNumber: 0,
    errorMessage: '',
    messageLabel: '',    
    statusCode:'',
    countryList : [],
    regionList:[],
    authenticationTypeList:[],
    authenticationMethodList:[]
} 